// extracted by mini-css-extract-plugin
module.exports = {"learn-more":"learn_more__learn-more___2yJGV _type__vx_text-6_lighter___2qDBi","learn-more-arrow":"learn_more__learn-more-arrow___1BtXw"};